import React, { useEffect, useState, useContext } from 'react';
import Header from '../Header/AppHeader';
import Axiosfetch from '../Common/Axiosfetch';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import baseURL from '../Common/Config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faSearch, faStamp, faTrash, faPen, faKey, faQrcode, faGem, faImages } from '@fortawesome/free-solid-svg-icons';
import AddOrganizations from '../Organization/AddOrganizations';
import FailureAlert from '../Common/Failure';
import { ThemeContext } from '../Common/ThemeProvider';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import DataTable from '../Common/DataTableList';
import {
    CallBackAlert, LicenseExpiryMessage,
    ValidateLicenseDetails
} from '../Common/Validations/validation';
import IsUndefinedNullOrEmpty from '../Common/Validations/valueCheck';

const licenseDetails = {
    ID: "",
    PartnerID: "",
    Remarks: "",
    Date: null,
    LastUpdated: null
};

const Organization = () => {
    const { CurrentTheme } = useContext(ThemeContext);
    const [organizationsData, setorganizationsData] = useState([]);
    const [organizationEditData, setorganizationEditData] = useState([]);
    const [displayAddOrganizations, setdisplayAddOrganizations] = useState("none");
    const [displayLogo, setdisplayLogo] = useState("none");
    const [displayPaymentLogo, setdisplayPaymentLogo] = useState("none");
    const [IsEdit, setIsEdit] = useState(0);
    const [FilterOrganizations, setFilterOrganizations] = useState([]);
    const [LogoImage, setLogoImage] = useState(null);
    const [PaymentImage, setPaymentImage] = useState(null);
    const [displayLicenseDetails, setdisplayLicenseDetails] = useState("none");
    const [displayPaymentDetails, setdisplayPaymentDetails] = useState("none");
    const [License, setLicense] = useState(licenseDetails);
    const [SelectedOrg, setSelectedOrg] = useState("");
    const [PaymentLogo, setPaymentLogo] = useState(null);
    const [UPI, setUPI] = useState("");
    const [SelectedUPI, setSelectedUPI] = useState("");
    const [SelectedOrgDetails, setSelectedOrgDetails] = useState({});
    const [IsAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        FetchOrganizations();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onOrganizationsSearch = (searchValue) => {
        if (searchValue !== "") {
            let userSearchData = organizationsData.filter(c => c.Name.trim().toLowerCase().includes(searchValue.trim().toLowerCase()) ||
                c.GSTNumber.trim().toLowerCase().includes(searchValue.trim().toLowerCase()));
            setFilterOrganizations(userSearchData);
        }
        else {
            setFilterOrganizations(organizationsData);
        }
    };

    const hideLicenseDetails = () => {
        setdisplayLicenseDetails("none");
        setLicense(licenseDetails);
    };

    const showUsers = () => {
        setdisplayAddOrganizations("block");
        setIsEdit(0);
    };

    const hidePaymentDetails = () => {
        setdisplayPaymentDetails("none");
    };

    const hideOrganization = () => {
        setdisplayAddOrganizations("none");
    };

    const EditSelectedUsers = (orgDetails) => {
        setorganizationEditData(orgDetails);
        setIsEdit(1);
        setdisplayAddOrganizations("block");
    };

    const DeleteSelectedOrg = (OrgID) => {
        Axiosfetch(baseURL + "DeleteOrganization", "POST", { ID: OrgID }, OrgDeleteSuccess, Failure);
    };

    const OrgDeleteSuccess = (data) => {
        if (data.success) {
            FetchOrganizations();
        }

        CallBackAlert(data);
    };

    const onUPIChange = (e) => {
        let value = e.target.value;
        setUPI(value);
    };

    const Failure = (err) => {
        FailureAlert(err);
    };

    const FetchOrganizations = () => {
        const userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
        if (userData !== null && userData.Role.length > 0 && userData.Role[0].Name.toUpperCase() !== "ADMIN") {
            setIsAdmin(false);
            Axiosfetch(baseURL + "GetActiveOrganizationByID", "POST", { ID: userData.OrganizationID }, OrgSuccess, Failure);
        }
        else {
            setIsAdmin(true);
            Axiosfetch(baseURL + "GetActiveOrganizations", "GET", null, OrgSuccess, Failure);
        }
    };

    const OrgSuccess = (data) => {
        if (data && data.length > 0) {
            var LicenseData = LicenseExpiryMessage(data);

            setorganizationsData(LicenseData);
            setFilterOrganizations(LicenseData);
        }
        else {
            setorganizationsData([]);
            setFilterOrganizations([]);
        }
    };

    const GetOrganizationLogo = (OrgID) => {
        let OrgDetails = organizationsData.filter(o => o._id === OrgID);
        if (OrgDetails.length > 0) {
            let file = OrgDetails[0].Logo;
            if (file !== null) {
                Axiosfetch(baseURL + "GetOrganizationLogo", "POST", { fileName: file }, LogoSuccess, Failure);
            }
        }
    };

    const GetPaymentLogo = (OrgID) => {
        let OrgDetails = organizationsData.filter(o => o._id === OrgID);
        if (OrgDetails.length > 0) {
            setSelectedUPI(OrgDetails[0].UPIID);
            setSelectedOrgDetails(OrgDetails[0]);
            setSelectedOrg(OrgID);
            let file = OrgDetails[0].PaymentLogo;
            if (file !== null) {
                Axiosfetch(baseURL + "GetPaymentLogo", "POST", { fileName: file }, PaymentSuccess, Failure);
            }
        }
    }

    const PaymentSuccess = (data) => {
        if (data.success) {
            setPaymentImage(data.fileData);
            setdisplayPaymentLogo("block");
        }
    };

    const LogoSuccess = (data) => {
        if (data.success) {
            setLogoImage(data.fileData);
            setdisplayLogo("block");
        }
    };

    const onWebSiteClick = (website) => {
        if (website !== "") {
            window.open((website.indexOf("http") === -1 ? "http://" : "") + website);
        }
    };

    const hideLogo = () => {
        setdisplayLogo("none");
    };

    const hidePaymentLogo = () => {
        setdisplayPaymentLogo("none");
    };

    const onLicenseShow = (OrgID) => {

        let selectedOrg = organizationsData.filter(o => o._id === OrgID);
        if (selectedOrg.length > 0 && selectedOrg[0].License.length > 0) {
            let selectedLicense = {
                ID: selectedOrg[0].License[0]._id,
                Remarks: selectedOrg[0].License[0].Remarks,
                Date: new Date(moment(selectedOrg[0].ExpiryDate)),
                LastUpdated: moment(selectedOrg[0].License[0].updatedAt).local().format("DD MMM YYYY hh:mm:ss A")
            };

            setLicense(selectedLicense);
        }

        setdisplayLicenseDetails("block");
        setSelectedOrg(OrgID);
    };

    const onPaymentShow = (OrgID) => {
        setSelectedOrg(OrgID);
        setdisplayPaymentDetails("block");
    };

    const onLicenseDateChange = (date) => {
        setLicense({ ...License, "Date": date });
    };

    const onTextChange = (e) => {
        setLicense({ ...License, [e.target.name]: e.target.value });
    };

    const OnLicenseSave = () => {
        if (ValidateLicenseDetails(License, SelectedOrg)) {
            let LicenseData = License;
            LicenseData.PartnerID = SelectedOrg;

            var apiurl = "CreateAppLicenseKey";
            if (License.ID !== undefined && License.ID !== "") {
                apiurl = "EditAppLicenseKey";
            }

            Axiosfetch(baseURL + apiurl, "POST", License, LicenseUpdateSuccess, Failure);
        }
    };

    const LicenseUpdateSuccess = (data) => {
        if (data.success) {
            setdisplayLicenseDetails("none");
            FetchOrganizations();
            setLicense(licenseDetails);
        }

        CallBackAlert(data);
    };

    const OnFileUpload = (e) => {
        var selectedFile = e.target.files[0];
        if (selectedFile.type === "image/jpeg" || selectedFile.type === "image/png" ||
            selectedFile.type === "image/jpg") {
            setPaymentLogo(selectedFile);
        }
        else {
            Alert.error("File Type allowed are : PNG , JPG, JPEG", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const OnPaymentSave = (fileName) => {
        if (!IsUndefinedNullOrEmpty(SelectedOrg) && !IsUndefinedNullOrEmpty(fileName)
            && !IsUndefinedNullOrEmpty(UPI)) {
            Axiosfetch(baseURL + "EditOrganizationPaymentCode", "POST",
                { _id: SelectedOrg, PaymentLogo: fileName, UpiID: UPI },
                PaymentFileUpdateSuccess, Failure);
        }
        else {
            Alert.error("Error Updating Payment Code.", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }

    };

    const PaymentFileUpdateSuccess = (data) => {
        if (data.success) {
            setdisplayPaymentDetails("none");
            FetchOrganizations();
            setPaymentLogo(null);
            setUPI("");
        }

        CallBackAlert(data);
    };

    const UploadPaymentCode = () => {
        if (PaymentLogo !== null) {
            let formData = new FormData();
            formData.append('file', PaymentLogo);
            Axiosfetch(baseURL + "UploadPaymentCode", "POST", formData, PaymentCodeUploadSuccess, Failure);
        }
        else {
            Alert.error("Please attach Payment Code file.", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const PaymentCodeUploadSuccess = (data) => {
        if (data.success) {
            OnPaymentSave(data.filename);
        }
        else {
            Alert.error(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const PaymentApproval = (isApproved) => {
        if (SelectedOrg !== "") {
            Axiosfetch(baseURL + "PaymentApprovalDeny", "POST", { IsApproved: isApproved, _id: SelectedOrg }, PaymentActionSuccess, Failure);
        }
        else {
            Alert.error("Error in Approving / Denying Payment QR Code", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const PaymentActionSuccess = (data) => {
        if (data.success) {
            setdisplayPaymentLogo("none");
            FetchOrganizations();
        }
        else {
            Alert.error(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const onLogoWaterMarkAction = (orgId, type) => {
        if (orgId !== "") {
            Axiosfetch(baseURL + "OrganizationLogoApproval", "POST", { LogoApproval: type, _id: orgId }, LogoActionSuccess, Failure);
        }
        else {
            Alert.error("Error in Logo Approval/Deny Action", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const OnPremiumSupport = (orgId, type) => {
        if (orgId !== "") {
            Axiosfetch(baseURL + "OrganizationIsPremiumSupport", "POST", { PremiumSupport: type, _id: orgId }, LogoActionSuccess, Failure);
        }
        else {
            Alert.error("Error in Logo Approval/Deny Action", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    }

    const LogoActionSuccess = (data) => {
        if (data.success) {
            Alert.success(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
            FetchOrganizations();
        }
        else {
            Alert.error(data.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const columns = [
        {
            name: "License",
            width: "85px",
            selector: (row) => {
                return <div style={{ fontSize: "1.2rem", textAlign: "center", width: "50px" }}>{(row.ExpiryDate !== undefined ? (<FontAwesomeIcon title={(row.ExpiryTimer !== undefined ? row.ExpiryTimer.days : "")}
                    style={{ color: (row.ExpiryTimer !== undefined ? row.ExpiryTimer.Color : "green") }} icon={faStamp}></FontAwesomeIcon>) : "-")}</div>
            }
        },
        {
            name: "Avatar",
            width: "80px",
            selector: (row) => {
                return row.Logo && (<div style={{ borderRadius: "30px" }} className="cursor" title="Click to see Profile Photo..." onClick={() => GetOrganizationLogo(row._id)}><img width="45" height="45" alt="Logo" src={`${baseURL}OrgLogo/${row.Logo}`}></img></div>)
            }
        },
        {
            name: 'Name',
            selector: row => { return <div style={{ whiteSpace: "normal", textAlign: "left", cursor: (row.Website === "" ? "default" : "pointer"), color: (row.Website === "" ? "" : "#005582") }} onClick={() => onWebSiteClick(row.Website)}>{row.Name}</div> },
        },
        {
            name: 'Address',
            width: "160px",
            wrap: true,
            selector: row => `${row.AddressLine1} ${row.AddressLine2} ${row.City} ${row.State} 
            ${row.PostalCode} ${row.Country}`,
            sortable: true,
        },
        {
            name: 'GST',
            wrap: true,
            selector: row => row.GSTNumber,
            sortable: true,
        },
        {
            name: 'PAN',
            wrap: true,
            selector: row => row.PANNumber === "" ? "-" : row.PANNumber,
            sortable: true,
        },
        {
            name: 'Contact',
            wrap: true,
            width: "140px",
            selector: row => {
                return (<div><div style={{
                    padding: "0 10px", borderRadius: "10px", color: "#1155ff", border: "1px solid #1155ff"
                }}><a style={{ color: "#1155ff", textDecoration: "none" }} href={`tel:+91${row.Contact}`}>{row.Contact}</a></div>
                    <div style={{
                        margin: "2px", borderRadius: "10px", color: "#1155ff"
                    }}>{row.AlternateContact === 0 ? "" :
                        <a style={{ padding: "0 10px", borderRadius: "10px", border: "1px solid #1155ff", color: "#1155ff", textDecoration: "none" }} href={`tel:+91${row.AlternateContact}`}>{row.AlternateContact}</a>}</div></div>)
            }
        },
        {
            name: 'QR',
            width: "70px",
            selector: row => { return (row.PaymentLogo && row.PaymentLogo !== "") ? (<span title="Payment QR Code" style={{ fontSize: "1.2rem", cursor: "pointer" }} onClick={() => GetPaymentLogo(row._id)}><FontAwesomeIcon icon={faQrcode}></FontAwesomeIcon></span>) : "-" },
        },
        {
            name: 'Created On',
            wrap: true,
            selector: row => moment(row.createdAt).local().format("DD/MM/YYYY"),
            sortable: true,
        },
        {
            name: 'Action',
            width: "220px",
            selector: (row) => {
                return (
                    <div>
                        <span className="cursorpointer" style={{ color: "#147a6f", marginLeft: "10px" }} title="Edit" onClick={() => EditSelectedUsers(row)} ><FontAwesomeIcon style={{ marginRight: "5px" }} icon={faPen} /></span>
                        {IsAdmin && (<span className="cursorpointer" style={{ color: "#f61414", marginLeft: "10px" }} title="Delete" onClick={() => DeleteSelectedOrg(row._id)} ><FontAwesomeIcon style={{ marginRight: "5px" }} icon={faTrash} /></span>)}
                        {IsAdmin && (<span className="cursorpointer" style={{ color: "#ccac00", marginLeft: "10px" }} title="License" onClick={() => onLicenseShow(row._id)}>
                            <FontAwesomeIcon style={{ marginRight: "5px" }} icon={faKey} />
                        </span>)}
                        {IsAdmin && (<span className="cursorpointer" style={{ color: (row.LogoApproval && row.LogoApproval === 1 ? "green" : "gray"), marginLeft: "10px" }}
                            title={`${row.LogoApproval && row.LogoApproval === 1 ? "Hide" : "Show"} Logo / Watermark`}
                            onClick={() => onLogoWaterMarkAction(row._id, (row.LogoApproval && row.LogoApproval === 1 ? 0 : 1))}>
                            <FontAwesomeIcon style={{ marginRight: "5px" }} icon={faImages} />
                        </span>)}
                        {IsAdmin && (<span className="cursorpointer" style={{ color: (row.PremiumSupport && row.PremiumSupport === 1 ? "orange" : "gray"), marginLeft: "10px" }}
                            title={`${row.PremiumSupport && row.PremiumSupport === 1 ? "Disable" : "Enable"} Premium Support`}
                            onClick={() => OnPremiumSupport(row._id, (row.PremiumSupport && row.PremiumSupport === 1 ? 0 : 1))}>
                            <FontAwesomeIcon style={{ marginRight: "5px" }} icon={faGem} />
                        </span>)}
                        <span className="cursorpointer" style={{ marginLeft: "10px", fontSize: "15px" }} title="Payment QR Code" onClick={() => onPaymentShow(row._id)}>
                            <FontAwesomeIcon icon={faQrcode} />
                        </span>
                    </div>
                )
            }
        }
    ];

    return (
        <div>
            <Header></Header>
            <div style={{ border: "none", boxShadow: "none" }} className="container-fluid InvoiceTheme sidemenu-show">
                <div className="row">
                    <div className="offset-md-2 col-md-4 col-sm-4">
                        <h5 className="align-right trackheader" style={{ fontWeight: "500" }}>MFI Organization</h5>
                    </div>
                    {IsAdmin && (<div className="offset-md-2 col-md-3 col-sm-6 col-10" style={{ display: "flex", position: "relative" }}>
                        <input type="text" name="Name" placeholder="Search Organization..."
                            className="form-control" style={{ marginRight: "10px", borderRadius: "20px", paddingLeft: "40px" }}
                            onChange={e => onOrganizationsSearch(e.target.value)}></input>
                        <div className={`${CurrentTheme}Color`} style={{ fontSize: "1rem", position: "absolute", left: "9%", top: "17%" }}>
                            <FontAwesomeIcon icon={faSearch} />
                        </div>
                    </div>)}
                    {IsAdmin && (<div className="col-md-1 col-sm-2 col-2 align-left">
                        <span data-tip="Add User" className={`cursor font-size-15rem addIconFocus ${CurrentTheme}Color`} onClick={showUsers}>
                            <FontAwesomeIcon icon={faPlus} />
                        </span>
                    </div>)}
                </div>
                <div className="row" style={{ padding: "15px" }}>
                    <div className='orgDataTable' style={{ width: "100%", textAlign: "center", border: "1px solid #ccc", borderRadius: "10px" }}>
                        <DataTable
                            columns={columns}
                            data={FilterOrganizations}
                        />
                    </div>
                </div>
                {displayAddOrganizations === "block" && <AddOrganizations themeColor={CurrentTheme} hideorganization={hideOrganization} getOrganization={FetchOrganizations} edit={IsEdit} organizationdetail={organizationEditData} allOrganization={organizationsData}></AddOrganizations>}
            </div>
            <div id="displayLogo" className="modal" style={{ display: displayLogo, paddingTop: "60px" }}>
                <div className="modal-content">
                    <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                        <span style={{ marginLeft: "5px", padding: "5px" }}>Organization Logo</span>
                        <span className="close" onClick={hideLogo}>&times;</span>
                    </div>
                    <div style={{ textAlign: "center" }}>
                        <img width="400" height="400" alt="org Logo" src={LogoImage}></img>
                    </div>
                </div>
            </div>
            <div id="displayPaymentLogo" className="modal" style={{ display: displayPaymentLogo, paddingTop: "60px" }}>
                <div className="modal-content">
                    <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                        <span style={{ marginLeft: "5px", padding: "5px" }}>Payment Code</span>
                        <span className="close" onClick={hidePaymentLogo}>&times;</span>
                    </div>
                    <div style={{ textAlign: "center" }}>
                        <img width="350" height="350" alt="Payment Code" src={PaymentImage}></img>
                        {IsAdmin && (<div style={{ textAlign: "right", marginBottom: "10px" }}>
                            {(SelectedOrgDetails.UPIApproval === undefined || SelectedOrgDetails.UPIApproval === 0) &&
                                (<span title="Approve Payment Code" className="hover-style button-style" onClick={() => PaymentApproval(1)}>Approve</span>)}
                            {(SelectedOrgDetails.UPIApproval !== undefined && SelectedOrgDetails.UPIApproval === 1) &&
                                (<span title="Deny Payment Code" className="hover-style button-style" onClick={() => PaymentApproval(0)}>Deny</span>)}</div>)}
                        <div style={{ color: "white", fontSize: "1.6rem" }} className={`${CurrentTheme}`}>UPI : {SelectedUPI}</div>
                    </div>
                </div>
            </div>
            <div id="LicenseModel" className="modal" style={{ display: displayLicenseDetails, paddingTop: "60px" }}>
                <div className="modal-content">
                    <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                        <span style={{ marginLeft: "5px", padding: "5px" }}>Update License</span>
                        <span className="close" onClick={hideLicenseDetails}>&times;</span>
                    </div>
                    <div className="align-center">
                        <table className="table">
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="text-field" style={{ padding: "10px" }}>
                                            <DatePicker className="TextInputStyle datepicker"
                                                onChange={onLicenseDateChange}
                                                selected={License.Date}
                                                name="Date"
                                                showTimeSelect
                                                timeIntervals={15}
                                                timeCaption="time"
                                                dateFormat="MMMM d, yyyy h:mm aa"></DatePicker>
                                            <span style={{ display: (License.Date !== null ? "none" : "block") }} className="datepickerPacking floating-span">Expiry Date<span className="mandatoryStar">*</span></span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="text-field">
                                            <input placeholder="" name="Remarks" value={License.Remarks ? License.Remarks : ""}
                                                onChange={(e) => onTextChange(e)}
                                                type="text"></input>
                                            <span>Remarks</span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div>
                                            Last Update : <b>{License.LastUpdated}</b>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="align-right">
                                        <button type="button" className="btn btn-Save" style={{ marginRight: "20px" }} onClick={OnLicenseSave}>Save</button>
                                        <button type="button" className="btn btn-default" onClick={hideLicenseDetails}>Close</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div id="PaymentModel" className="modal" style={{ display: displayPaymentDetails, paddingTop: "60px" }}>
                <div className="modal-content">
                    <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                        <span style={{ marginLeft: "5px", padding: "5px" }}>Update Payment</span>
                        <span className="close" onClick={hidePaymentDetails}>&times;</span>
                    </div>
                    <div className="align-center">
                        <table className="table">
                            <tbody>
                                <tr>
                                    <td>
                                        <input type="file" name="Logo"
                                            className="form-control"
                                            onChange={e => OnFileUpload(e)}
                                            accept="image/jpeg, image/png"></input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="text-field">
                                            <input placeholder="" name="UPI" value={UPI}
                                                onChange={(e) => onUPIChange(e)}
                                                type="text"></input>
                                            <span>UPI ID<span className="mandatoryStar">*</span></span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="align-right">
                                        <button type="button" className="btn btn-Save" style={{ marginRight: "20px" }} onClick={UploadPaymentCode}>Save</button>
                                        <button type="button" className="btn btn-default" onClick={hidePaymentDetails}>Close</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Organization;